import React, {useEffect, useRef, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import classnames from 'classnames';
import WindowEventHelper from "../../lib/WindowEventHelper";
import {isDescendant} from "../../lib/DomUtils";
import {changeCategory} from "../../actions/post";
import {CategoryListPanel} from "./CategoryListPanel";
import {getCategoryDisplayName} from "../../lib/PostUtils"

function DefaultCategorySelect({label}) {
  return (
    <div className="btn-category" role="button">
      <div className='default-label'>
        {label}
      </div>
    </div>
  )
}

function PostCategorySelect() {
  const categoryId = useSelector(state => state.post.newPost.category)
  const categories = useSelector(state => state.blog.categories)
  const dispatch = useDispatch()

  const [openCategory, setOpenCategory] = useState(false)
  const rootElm = useRef(null)

  function handleSelectCategory(categoryId, viewChanel) {
    dispatch(changeCategory(categoryId, viewChanel))
    setOpenCategory(false)
  }

  function handleWindowClick(e) {
    if (isDescendant(rootElm.current, e.target)) {
      return;
    }
    setOpenCategory(false)
  }

  function handleToggleCategory(e) {
    setOpenCategory(!openCategory)
  }


  function selectedCategoryName() {
    let selected = categories.find(c => c.id == categoryId)
    if (!selected) {
      selected = categories.flatMap(c => c.children? c.children : []).find(c => c && c.id == categoryId)
    }

    if (selected && selected.id > 0) {
      return getCategoryDisplayName(selected)
    } else {
      return '카테고리'
    }
  }

  useEffect(() => {
    WindowEventHelper.add('click', handleWindowClick)
    return () => {
      WindowEventHelper.remove('click', handleWindowClick)
    }
  }, [])

  return (
    <div ref={rootElm} className="btn-category" role="button">
      <div className={classnames('mce-widget mce-btn', {'mce-opened': openCategory})} role='button'>
        <button type="button" onClick={handleToggleCategory}>
          <i className="mce-txt">{selectedCategoryName()}</i>
          <i className="mce-caret">더보기</i>
        </button>
      </div>

      {openCategory &&
        <CategoryListPanel categories={categories} onSelect={handleSelectCategory}/>
      }
    </div>
  )
}

export default function CategorySelect() {
  switch (window.Config.postType) {
    case 'page':
      return <DefaultCategorySelect label='페이지' />
    case 'notice':
      return <DefaultCategorySelect label='공지사항' />
    case 'keyword':
      return <DefaultCategorySelect label='키워드' />
    case 'template':
      return <DefaultCategorySelect label='서식' />
    case 'post':
    default:
      return <PostCategorySelect />
  }
}
